export default __webpack_public_path__ + "static/media/Hape-Bug-Maze-1.dfd50fd1.jpg";